var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"list"},[_c(_vm.component,{key:"infiniteCellList",tag:"component",attrs:{"cell-list":_vm.cellList,"thumbnail-info":_vm.thumbnailInfo,"container-class-name":_vm.containerClassName,"content-info":_vm.contentInfo,"loading":_vm.loading},on:{"cell-click-log":_vm.sendCellClickLog}}),_c('div',{ref:"scrollMonitor"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }